import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "product-detail" }
const _hoisted_5 = { class: "product-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "product-body" }
const _hoisted_8 = { class: "product-description" }
const _hoisted_9 = {
  key: 0,
  class: "product-sections"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Lorem", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, " → ", -1)),
          _createVNode(_component_router_link, { to: "/products" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Ipsum", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, " → ", -1)),
          _createElementVNode("span", null, _toDisplayString($props.pageTitle), 1)
        ]),
        _createElementVNode("h1", _hoisted_3, _toDisplayString($props.pageTitle), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: $props.imageUrl,
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString($props.description), 1),
            _cache[4] || (_cache[4] = _createElementVNode("a", {
              href: "#",
              class: "btn-cta"
            }, "Lorem Ipsum", -1))
          ])
        ]),
        ($props.sections.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sections, (section, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "section-card"
                }, [
                  _createElementVNode("h3", null, _toDisplayString(section.title), 1),
                  _createElementVNode("p", null, _toDisplayString(section.text), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("a", {
                    href: "#",
                    class: "section-link"
                  }, "Lorem Ipsum", -1))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}